import { AVES } from './constants';

export const aveColor = (name: string) =>
  AVES.find((a) => a.name === name)?.color.dark || '';

export const aveShineColor = (name: string) =>
  AVES.find((a) => a.name === name)?.shineColor.dark || '';

export const aveName = (score: number) => {
  const found = AVES.find((a) => a.score === score)?.name;
  if (found) return found;
  if (score < -6) return 'pterodactyl'; // scores shouldn't be less than -6, but if achieved, still ptero
  return '';
};
